export default "__VITE_ASSET__BqD3INw4__";